import React from "react";
import Play from "../SVGs/Play";

type CircularButtonType = {
  onClick: () => void;
  className?: string;
};

const CircularButton: React.FC<CircularButtonType> = ({
  onClick,
  className,
}) => {
  return (
    <button
      type="button"
      className={`circular-button ${className}`}
      onClick={onClick}
    >
      <Play />
    </button>
  );
};

export default CircularButton;
